import { ReactNode } from 'react';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import Dialog from '@sorare/core/src/components/dialog';
import { Header } from '@sorare/core/src/components/dialog/Header';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Content = styled(FullWidthContainer)`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  padding-top: var(--double-unit);
  padding-bottom: var(--double-unit);
`;

const TwoColumn = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: minmax(10px, 1fr);
  --top-offset: 72px;
  height: 100%;
  overflow: auto;
  @media ${laptopAndAbove} {
    --top-offset: 80px;
    height: calc(var(--100vh) - var(--top-offset));
    max-height: calc(var(--100vh) - var(--top-offset));
    grid-template-columns: 1fr 580px;
    > *:first-child {
      height: max-content;
      min-height: calc(100vh - 80px);
      position: sticky;
      top: 0;
    }
  }
  > *:nth-child(2) {
    padding-bottom: 0;
  }
`;

export type Props = {
  title: ReactNode;
  children?: ReactNode;
  tokenPreview: ReactNode;
  onBack?: () => void;
  onClose?: () => void;
};

export const PaymentDialog = ({
  title,
  children,
  tokenPreview,
  onBack,
  onClose,
}: Props) => {
  const isLaptop = useIsLaptop();
  const { up: upTablet } = useScreenSize('tablet');
  return (
    <Dialog
      open
      maxWidth="lg"
      fullWidth
      onBack={onBack}
      onClose={onClose}
      fullScreen={!upTablet}
      hideHeader={isLaptop}
      title={title}
    >
      <TwoColumn>
        {tokenPreview}
        <Content>
          {isLaptop && (
            <Header
              onBack={onBack}
              title={<div className="text-center">{title}</div>}
              onClose={onClose}
            />
          )}
          {children}
        </Content>
      </TwoColumn>
    </Dialog>
  );
};

export default PaymentDialog;
